import { ProductInfo } from './product_info'

export class Product {
  constructor(product) {
    this.product = new ProductInfo(product.product),
    this.quantity = product.quantity
  }
}
